import { UPDATE_LIST } from '../../../integrations/list'

/**
 * @typedef {Object} UsersState Map of User entities
 */

/**
 * @param {UsersState} initialState
 * @returns {(state: UsersState, action: Object) => UsersState}
 */
export default function usersReducer(initialState) {
    return (state = initialState, action) => {
        switch (action.type) {
            case UPDATE_LIST:
                return action.data.users

            default:
                return state
        }
    }
}
